import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SetSalesPortalOrderGuideCollectionDocument = gql`
  mutation setSalesPortalOrderGuideCollection(
    $collectionUUID: uuid!
    $collectionName: String
    $partitions: [SetOrderGuideCollectionPartitionInput!]!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    setOrderGuideCollection(
      collection_id: $collectionUUID
      collection_name: $collectionName
      partitions: $partitions
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      order_guide_collection_id
    }
  }
`;
export type SetSalesPortalOrderGuideCollectionMutationFn =
  Apollo.MutationFunction<
    Types.SetSalesPortalOrderGuideCollectionMutation,
    Types.SetSalesPortalOrderGuideCollectionMutationVariables
  >;
export function useSetSalesPortalOrderGuideCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SetSalesPortalOrderGuideCollectionMutation,
    Types.SetSalesPortalOrderGuideCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SetSalesPortalOrderGuideCollectionMutation,
    Types.SetSalesPortalOrderGuideCollectionMutationVariables
  >(SetSalesPortalOrderGuideCollectionDocument, options);
}
export type SetSalesPortalOrderGuideCollectionMutationHookResult = ReturnType<
  typeof useSetSalesPortalOrderGuideCollectionMutation
>;
export type SetSalesPortalOrderGuideCollectionMutationResult =
  Apollo.MutationResult<Types.SetSalesPortalOrderGuideCollectionMutation>;
export type SetSalesPortalOrderGuideCollectionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SetSalesPortalOrderGuideCollectionMutation,
    Types.SetSalesPortalOrderGuideCollectionMutationVariables
  >;
